(function () {
  'use strict';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initCountdown(root) {
    var bar = root.querySelector('[data-jgr-offer-countdown]') || root.querySelector('[data-jgr-countdown]');
    if (!bar || !bar.dataset.countdownEnd) return;

    var endTime = Date.parse(bar.dataset.countdownEnd);
    var clock = bar.querySelector('[data-countdown-clock]');
    var label = bar.querySelector('[data-countdown-label]');
    if (!clock || Number.isNaN(endTime)) {
      if (bar.hasAttribute('data-jgr-offer-countdown')) bar.hidden = true;
      else if (clock) clock.hidden = true;
      return;
    }

    var days = bar.querySelector('[data-countdown-days]');
    var hours = bar.querySelector('[data-countdown-hours]');
    var minutes = bar.querySelector('[data-countdown-minutes]');
    var seconds = bar.querySelector('[data-countdown-seconds]');
    var timerId;

    function update() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        window.clearInterval(timerId);
        if (bar.hasAttribute('data-jgr-offer-countdown')) {
          bar.hidden = true;
        } else {
          clock.hidden = true;
          if (label) label.textContent = bar.dataset.countdownExpired || 'Current bundle pricing';
        }
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      days.textContent = pad(Math.floor(totalSeconds / 86400));
      hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      seconds.textContent = pad(totalSeconds % 60);
    }

    update();
    timerId = window.setInterval(update, 1000);
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-jgr-gallery]');
    if (!gallery) return;

    var buttons = Array.prototype.slice.call(gallery.querySelectorAll('[data-jgr-gallery-button]'));
    var panels = Array.prototype.slice.call(gallery.querySelectorAll('[data-jgr-panel]'));

    function activate(targetId, focusButton) {
      buttons.forEach(function (button) {
        var selected = button.dataset.target === targetId;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        button.tabIndex = selected ? 0 : -1;
        if (selected && focusButton) button.focus();
      });

      panels.forEach(function (panel) {
        var selected = panel.dataset.jgrPanel === targetId;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
        if (!selected) {
          panel.querySelectorAll('video').forEach(function (video) {
            try { video.pause(); } catch (error) { /* no-op */ }
          });
        }
      });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        activate(button.dataset.target, false);
      });

      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        activate(buttons[nextIndex].dataset.target, true);
      });
    });
  }

  function initVariantPicker(root) {
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-jgr-variant-option]'));
    var input = root.querySelector('[data-jgr-main-variant-input]');
    var submit = root.querySelector('[data-jgr-main-submit]');
    if (!options.length || !input || !submit) return;

    var title = root.querySelector('[data-jgr-selected-title]');
    var price = root.querySelector('[data-jgr-price]');
    var compare = root.querySelector('[data-jgr-compare-price]');
    var perSet = root.querySelector('[data-jgr-per-set]');
    var saving = root.querySelector('[data-jgr-saving]');
    var shipping = root.querySelector('[data-jgr-shipping]');
    var badge = root.querySelector('[data-jgr-offer-badge]');
    var stickyPrices = Array.prototype.slice.call(document.querySelectorAll('[data-jgr-sticky-price]'));

    function selectOption(option, updateUrl) {
      if (!option) return;

      options.forEach(function (candidate) {
        var selected = candidate === option;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-checked', selected ? 'true' : 'false');
      });

      var available = option.dataset.available === 'true';
      input.value = option.dataset.variantId;
      if (title) title.textContent = option.dataset.title || '';
      if (price) price.textContent = option.dataset.price || '';
      if (perSet) perSet.textContent = option.dataset.perSet || '';
      if (shipping) shipping.textContent = option.dataset.shipping || '';
      stickyPrices.forEach(function (stickyPrice) {
        stickyPrice.textContent = option.dataset.price || '';
      });

      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.saving;
      }

      if (saving) {
        saving.textContent = option.dataset.saving || '';
        saving.hidden = !option.dataset.saving;
      }

      if (badge) {
        badge.textContent = option.dataset.badge || '';
        badge.hidden = !option.dataset.badge;
      }

      submit.disabled = !available;
      if (available) {
        var selectedTitle = (option.dataset.title || '').toUpperCase();
        var selectedPrice = option.dataset.price || '';
        submit.textContent = (submit.dataset.ctaPrefix || 'ADD') + ' ' + selectedTitle + (selectedPrice ? ' — ' + selectedPrice : '');
      } else {
        submit.textContent = submit.dataset.soldOutLabel;
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));

      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.dataset.variantId);
        window.history.replaceState({}, '', url.toString());
      }
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        selectOption(option, true);
      });

      option.addEventListener('keydown', function (event) {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          selectOption(option, true);
        }
      });
    });

    var selected = root.querySelector('[data-jgr-variant-option].is-selected') || options.find(function (option) {
      return option.dataset.available === 'true';
    }) || options[0];
    selectOption(selected, false);
  }

  function initForms(root) {
    root.querySelectorAll('[data-jgr-product-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var button = form.querySelector('button[type="submit"]');
        if (!button || button.disabled) return;
        button.setAttribute('aria-busy', 'true');
        button.dataset.originalText = button.textContent;
        button.textContent = 'Adding...';
        window.setTimeout(function () {
          button.removeAttribute('aria-busy');
          button.textContent = button.dataset.originalText || 'Add to cart';
        }, 3500);
      });
    });
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-jgr-sticky]');
    var purchase = document.querySelector('[data-jgr-purchase]');
    var scrollButton = root.querySelector('[data-jgr-scroll-buy]');
    if (!sticky || !purchase) return;
    if (sticky.hasAttribute('data-jgr-sticky-mode')) return;

    if (scrollButton) {
      scrollButton.addEventListener('click', function () {
        purchase.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { threshold: 0.16 });
      observer.observe(purchase);
    }
  }

  function init(root) {
    if (!root || root.dataset.jgrReady === 'true') return;
    root.dataset.jgrReady = 'true';
    document.body.classList.add('joistr-template');
    initCountdown(root);
    initGallery(root);
    initVariantPicker(root);
    initForms(root);
    initSticky(root);
  }

  function initAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches('[data-jgr-root]')) init(target);
    target.querySelectorAll('[data-jgr-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
